import { LanguageSelector } from '@infl-ts/ui-advocate-components';
import { useFreezer } from '@infl-ts/util-freezer';
import { Box, Divider, MenuList } from '@mui/material';
import * as RA from 'fp-ts/ReadonlyArray';
import { useEffect, useRef } from 'react';
import { AccountMenuLinks } from './account-menu-links';
import AuthButtons from './auth-buttons';
import MobileNavLinks from './mobile-nav-links';
import ProfileLink from './profile-link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var MobileAccountMenu = function MobileAccountMenu(_ref) {
  var profile = _ref.profile,
      links = _ref.links,
      isDesktop = _ref.isDesktop,
      isPopoverOpen = _ref.isPopoverOpen,
      handlePopoverClose = _ref.handlePopoverClose,
      signinEnabled = _ref.signinEnabled,
      signupEnabled = _ref.signupEnabled,
      privacyPolicyLink = _ref.privacyPolicyLink,
      termsAndConditionsLink = _ref.termsAndConditionsLink,
      memberMessagingEnabled = _ref.memberMessagingEnabled,
      navLangSelectorEnabled = _ref.navLangSelectorEnabled,
      actionBarLangSelectorEnabled = _ref.actionBarLangSelectorEnabled;
  var ref = useRef(null);
  var profileRef = useRef(null);

  var _useFreezer = useFreezer(),
      freeze = _useFreezer.freeze,
      unfreeze = _useFreezer.unfreeze;

  useEffect(function () {
    isPopoverOpen ? freeze() : unfreeze();
    return function () {
      unfreeze();
    };
  }, [isPopoverOpen, freeze, unfreeze]);
  return /*#__PURE__*/_jsxs(MenuList, {
    sx: {
      width: '100vw',
      maxWidth: 'auto',
      height: '100vh',
      overflowY: 'auto',
      pb: 17,
      boxSizing: 'border-box'
    },
    id: "customized-menu",
    "data-element": "MenuList",
    "data-component": "MobileAccountMenu",
    "data-source-file": "mobile-account-menu.tsx",
    children: [profile ? /*#__PURE__*/_jsxs(Box, {
      children: [/*#__PURE__*/_jsx(ProfileLink, {
        ref: profileRef,
        profile: profile,
        isDesktop: isDesktop,
        onClick: handlePopoverClose
      }), /*#__PURE__*/_jsx(Divider, {})]
    }) : null, /*#__PURE__*/_jsxs(Box, {
      ref: ref,
      sx: {
        position: 'relative',
        overflowX: 'hidden'
      },
      "data-element": "Box",
      "data-component": "MobileAccountMenu",
      "data-source-file": "mobile-account-menu.tsx",
      children: [/*#__PURE__*/_jsx(MobileNavLinks, {
        links: links,
        container: ref.current,
        handleClosePopover: handlePopoverClose,
        "data-element": "MobileNavLinks",
        "data-component": "MobileAccountMenu",
        "data-source-file": "mobile-account-menu.tsx"
      }), profile ? /*#__PURE__*/_jsx(AccountMenuLinks, {
        handlePopoverClose: handlePopoverClose,
        privacyPolicyLink: privacyPolicyLink,
        termsAndConditionsLink: termsAndConditionsLink,
        memberMessagingEnabled: memberMessagingEnabled,
        actionBarLangSelectorEnabled: actionBarLangSelectorEnabled
      }) : null, navLangSelectorEnabled ? /*#__PURE__*/_jsx(LanguageSelector, {
        containerSx: {
          mt: 1.5,
          px: 1,
          display: {
            xs: 'flex',
            lg: 'none'
          }
        },
        reloadOnLanguageChange: true
      }) : null, (signinEnabled || signupEnabled) && RA.isNonEmpty(links) ? /*#__PURE__*/_jsx(Divider, {
        sx: {
          my: 1
        }
      }) : null, signinEnabled || signupEnabled ? /*#__PURE__*/_jsx(AuthButtons, {
        containerSx: {
          mt: 1.5,
          px: 1,
          display: {
            xs: 'flex',
            md: 'none'
          }
        },
        signInVariant: "outlined",
        sx: {
          width: 1
        },
        signinEnabled: signinEnabled,
        signupEnabled: signupEnabled
      }) : null]
    })]
  });
};

export default MobileAccountMenu;